import { LoanDefinitionType } from '@dealstack/shared/lib/generated';
import { HoldingOrLoan } from './holdingTable.types';

export const isLoanHolding = (holding: HoldingOrLoan): boolean =>
	holding.type === LoanDefinitionType.MANAGEMENT_LOAN ||
	holding.type === LoanDefinitionType.DEFERRED_PAYMENT;

export const buildLoanRowName = ({
	name,
	funder,
	issuerName,
	isViaVehicle,
	heldByLabel,
	viaLabel,
}: {
	name: string;
	funder: string;
	issuerName: string | null;
	isViaVehicle: boolean;
	heldByLabel: string;
	viaLabel: (issuer: string) => string;
}): string => {
	const label = `${name} (${heldByLabel} ${funder.replace(LoanDefinitionType.MANAGEMENT_LOAN, '')})`;

	return isViaVehicle && issuerName ? `${label} · ${viaLabel(issuerName)}` : label;
};
